import { mapGetters } from 'vuex'
export default {
  name: 'BalanceIndicator',
  components: {},
  props: ["noPendingDues", "creditUsed"],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'foodForThought',
      'availableCreditLimit',
      'outstandingAmount',
      'unsettledTransactionList'
    ])
  },
  mounted () {
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/BalanceIndicator/component.js